var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u062D\\u0633\\u0627\\u0628_\\u06A9\\u0627\\u0631\\u0628\\u0631\\u06CC",
    "data-name": "\\u062D\\u0633\\u0627\\u0628 \\u06A9\\u0627\\u0631\\u0628\\u0631\\u06CC",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M13.333,13.667a5.333,5.333,0,1,1,5.333-5.333A5.333,5.333,0,0,1,13.333,13.667Z",
    transform: "translate(2.667 1)",
    fill: "#333",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask-Copy",
    d: "M3,22.6C3.518,16.235,8.683,13,14.978,13,21.362,13,26.607,16.058,27,22.6a.916.916,0,0,1-1,1.067H3.97A1.476,1.476,0,0,1,3,22.6Z",
    transform: "translate(1 4.333)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.91b46dfe396ab0927a587d3b7f4b13c3.svg";
export { ForwardRef as ReactComponent };